<template>
  <div>
    <app-head></app-head>
    <app-body>
      <div>
        <!-- Banner -->
        <div class="cd-banner">
          <div class="banner-content-white-text">
            <div class="case-center-card">
              <h1 class="main-title" style="font-family: STCaiyun, Arial, sans-serif;">{{ caseData.title }}</h1>
              <hr>
              <h2 class="sub-title">CASE STUDY</h2>
            </div>
          </div>
          <div class="breadcrumb-container">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>
                <router-link to="/"><i class="el-icon-house"></i> 首页</router-link>
              </el-breadcrumb-item>
              <el-breadcrumb-item>
                <router-link to="/customerCases">客户案例</router-link>
              </el-breadcrumb-item>
              <el-breadcrumb-item>{{ caseData.title }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>

        <div class="cd-container">
          <!-- 摘要 -->
          <el-card class="cd-block" shadow="never">
            <div slot="header" class="cd-block-header">方案摘要</div>
            <p class="cd-summary" v-html="caseData.summary"></p>
            <div class="cd-tags">
              <el-tag v-for="t in caseData.tags" :key="t" effect="plain" class="cd-tag">{{ t }}</el-tag>
            </div>
          </el-card>

          <!-- 挑战 / 方案 / 成效 -->
          <el-card class="cd-block" shadow="never">
            <div slot="header" class="cd-block-header">
              <span class="cd-label">{{ caseData.caseLabel }}</span> {{ caseData.caseMainTitle }}
            </div>
            <p class="cd-sub">{{ caseData.caseMainDesc }}</p>
            <el-row :gutter="18" class="cd-three">
              <el-col :span="8">
                <div class="cd-mini c1">
                  <div class="cd-mini-head">01 / 挑战</div>
                  <h3>{{ caseData.challengesTitle }}</h3>
                  <ul>
                    <li v-for="(c,i) in caseData.challenges" :key="i">{{ c }}</li>
                  </ul>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="cd-mini c2">
                  <div class="cd-mini-head">02 / 方案</div>
                  <h3>{{ caseData.solutionsTitle }}</h3>
                  <ul>
                    <li v-for="(c,i) in caseData.solutions" :key="i">{{ c }}</li>
                  </ul>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="cd-mini c3">
                  <div class="cd-mini-head">03 / 成效</div>
                  <h3>{{ caseData.resultsTitle }}</h3>
                  <ul>
                    <li v-for="(c,i) in caseData.results" :key="i">{{ c }}</li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </el-card>

          <!-- 系统架构 -->
          <el-card class="cd-block" shadow="never">
            <div slot="header" class="cd-block-header">系统架构</div>
            <div class="cd-arch">
              <template v-for="(n,i) in caseData.archNodes">
                <div class="cd-node" :key="'n'+i">
                  <h4>{{ n.title }}</h4>
                  <div class="cd-node-sub">{{ n.sub }}</div>
                </div>
                <div class="cd-arrow" v-if="i < caseData.archNodes.length-1" :key="'a'+i">⟷</div>
              </template>
            </div>
            <div class="cd-note"><span class="cd-lock">🔒</span><span v-html="caseData.archNote"></span></div>
            <div class="cd-tags">
              <el-tag v-for="(t,i) in caseData.archTags" :key="i" effect="plain" class="cd-tag-arch">
                <b>{{ t.abbr }}</b> {{ t.desc }}
              </el-tag>
            </div>
          </el-card>

          <!-- 核心能力 -->
          <el-card class="cd-block" shadow="never">
            <div slot="header" class="cd-block-header">核心能力</div>
            <el-row :gutter="14" class="cd-feat-grid">
              <el-col :span="8" v-for="(f,i) in caseData.features" :key="i">
                <div class="cd-feat">
                  <div class="cd-feat-gif">
                    <template v-if="f.title === '私有化部署'">
                      <svg class="cd-feat-svg" viewBox="0 0 380 150" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient id="cdNode" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stop-color="#2a7c7e"/>
                            <stop offset="100%" stop-color="#0B2A4A"/>
                          </linearGradient>
                        </defs>

                        <!-- 内网边界 -->
                        <rect x="8" y="12" width="300" height="126" rx="10"
                              fill="#f2f8f8" stroke="#2a7c7e" stroke-width="1.5" stroke-dasharray="6 4"/>
                        <text x="18" y="30" font-size="12" font-weight="700" fill="#0B2A4A" font-family="'Microsoft YaHei',sans-serif">内网（私有域）</text>

                        <!-- 连接线 -->
                        <path d="M70,58 L154,43" stroke="#cbd5e1" stroke-width="1.5" fill="none"/>
                        <path d="M154,43 L238,58" stroke="#cbd5e1" stroke-width="1.5" fill="none"/>
                        <path d="M70,58 Q154,108 238,58" stroke="#cbd5e1" stroke-width="1.5" fill="none"/>

                        <!-- 流动数据包 -->
                        <circle r="3" fill="#2a7c7e">
                          <animateMotion dur="2s" repeatCount="indefinite" path="M70,58 L154,43"/>
                        </circle>
                        <circle r="3" fill="#0B2A4A">
                          <animateMotion dur="2s" repeatCount="indefinite" path="M154,43 L70,58"/>
                        </circle>
                        <circle r="3" fill="#2a7c7e">
                          <animateMotion dur="2.2s" repeatCount="indefinite" path="M154,43 L238,58"/>
                        </circle>
                        <circle r="3" fill="#0B2A4A">
                          <animateMotion dur="2.2s" repeatCount="indefinite" path="M238,58 L154,43"/>
                        </circle>
                        <circle r="3" fill="#2a7c7e">
                          <animateMotion dur="3s" repeatCount="indefinite" path="M70,58 Q154,108 238,58"/>
                        </circle>
                        <circle r="3" fill="#0B2A4A">
                          <animateMotion dur="3s" repeatCount="indefinite" path="M238,58 Q154,108 70,58"/>
                        </circle>

                        <!-- 节点：主控端 -->
                        <rect x="44" y="47" width="52" height="22" rx="5" fill="url(#cdNode)"/>
                        <text x="70" y="62" font-size="11" fill="#fff" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">主控端</text>
                        <!-- 节点：中央服务集群 -->
                        <rect x="128" y="32" width="52" height="22" rx="5" fill="url(#cdNode)"/>
                        <text x="154" y="47" font-size="11" fill="#fff" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">中央集群</text>
                        <!-- 节点：被控端 -->
                        <rect x="212" y="47" width="52" height="22" rx="5" fill="url(#cdNode)"/>
                        <text x="238" y="62" font-size="11" fill="#fff" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">被控端</text>

                        <!-- 底部说明 -->
                        <text x="158" y="132" font-size="11" font-weight="700" fill="#2a7c7e" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">数据全程不出域 · 满足等保合规</text>

                        <!-- 互联网（隔离，无连线） -->
                        <rect x="316" y="56" width="58" height="38" rx="9" fill="#f4f6f8" stroke="#cbd5e1" stroke-width="1.2"/>
                        <text x="345" y="74" font-size="11" fill="#64748b" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">🌐 互联网</text>
                        <text x="345" y="88" font-size="10" fill="#94a3b8" text-anchor="middle" font-family="'Microsoft YaHei',sans-serif">外部不可达</text>
                        <!-- 禁止外联标记 -->
                        <text x="308" y="78" font-size="16" text-anchor="middle">🚫</text>
                      </svg>
                    </template>
                    <img v-else :src="'/customerCase/feat' + (i+1) + '.gif'" :alt="f.title"
                         @error="$event.target.parentNode.style.display='none'">
                  </div>
                  <h4>{{ f.title }}</h4>
                  <p>{{ f.desc }}</p>
                </div>
              </el-col>
            </el-row>
          </el-card>

          <!-- 技术亮点 -->
          <el-card class="cd-block" shadow="never">
            <div slot="header" class="cd-block-header">技术亮点</div>
            <el-row :gutter="12" class="cd-tech-grid">
              <el-col :span="12" v-for="(t,i) in caseData.techs" :key="i">
                <div class="cd-tech">
                  <span class="cd-tech-icon"><i class="el-icon-check"></i></span>
                  <div>
                    <b>{{ t.title }}</b>
                    <span class="cd-tech-desc">{{ t.desc }}</span>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>

          <!-- 方案信息 -->
          <el-card class="cd-block" shadow="never">
            <div slot="header" class="cd-block-header">方案信息</div>
            <el-descriptions :column="1" border>
              <el-descriptions-item label="交付内容">{{ caseData.info.deliver }}</el-descriptions-item>
              <el-descriptions-item label="适用场景">{{ caseData.info.scene }}</el-descriptions-item>
              <el-descriptions-item label="部署方式">{{ caseData.info.deploy }}</el-descriptions-item>
              <el-descriptions-item label="交付周期">{{ caseData.info.cycle }}</el-descriptions-item>
              <el-descriptions-item label="服务保障">{{ caseData.info.service }}</el-descriptions-item>
            </el-descriptions>
          </el-card>

          <!-- CTA -->
          <div class="cd-cta">
            <h2>{{ caseData.cta.title }}</h2>
            <p>{{ caseData.cta.desc }}</p>
            <el-button type="primary" size="medium" @click="onContact">预约演示 / 联系我们</el-button>
          </div>
        </div>
      </div>
    </app-body>
    <app-foot></app-foot>
  </div>
</template>

<script>
import AppHead from '../common/AppHeader.vue';
import AppBody from '../common/AppPageBody.vue'
import AppFoot from '../common/AppFoot.vue'

export default {
  name: "CustomerCaseDetail",
  components: {AppHead, AppBody, AppFoot},
  data() {
    return {
      caseData: {},
      // ===== 本页面对应一个方案，数据即此 caseData =====
      caseMap: {
        1: {
          title: 'FOCUS - 智能制造全栈式融合管控平台',
          subtitle: '将分散在多地网点、厂区、坐席的终端纳入统一远程运维与质检平台，实现屏幕实时查看、远程操控、录音复听与自动化运维——数据全程不出域。',
          summary: '通过部署我司自研的远程桌面集中管控系统，将分布在产线静音房的工控机纳入统一远程运维与质检平台，实现屏幕实时查看、远程操控、录音复听、集中告警与自动化运维。原需<strong>多名</strong>操作员到现场巡检的终端，现由<strong>一人</strong>在控制台统一管控，运维人力投入显著降低；品控人员无需再逐一跑各个静音房，且 NG 音频可直接复听复判，大幅减少平均故障响应时间。',
          tags: ['WebRTC 低延迟传输', '私有化部署', '数据不出域', '跨平台桌面端', '无人值守常驻'],
          caseLabel: '客户案例',
          caseMainTitle: '从"人跑现场"到"统一管控"',
          caseMainDesc: '部署后，运维模式与合规能力发生根本性改变。',
          challengesTitle: '上线前的痛点',
          challenges: ['终端分散，运维靠"人跑"', '无统一视图，状态不可见', '操作难追溯、质检难落地', '重复劳动多，无人值守弱'],
          solutionsTitle: '我们的交付',
          solutions: ['主控端控制台 + 被控端程序', '中央服务集群私有化部署', '实时控制 + 集中监控', '录音复听 + 操作审计闭环'],
          resultsTitle: '方案收益',
          results: ['运维从静音房转为统一管控', '操作全程留痕，合规增强', '批量自动化替代重复人工', '团队精力聚焦核心业务'],
          archNodes: [
            {title: '主控端（控制台）', sub: '管理员电脑 · 桌面应用'},
            {title: '中央服务集群', sub: '信令 / TURN / 注册 / 下发'},
            {title: '被控端（每台终端）', sub: '工控机 / 坐席 / 前台 · 常驻'},
          ],
          archNote: '整套系统支持<strong>完全私有化部署</strong>于内网，所有信令、媒体流与业务数据均留在域内，满足安全合规要求。',
          archTags: [
            {abbr: 'WebRTC', desc: '点对点低延迟传输'},
            {abbr: 'Leader 选举', desc: '多连接协同'},
            {abbr: '分块续传', desc: '大文件不丢数据'},
            {abbr: '会话留痕', desc: '后端自愈兜底'},
            {abbr: '跨平台', desc: '托盘 / 自启 / 常驻'},
          ],
          features: [
            {
              title: '实时远程控制',
              desc: '主控端即可查看并操控任意终端屏幕，鼠标键盘指令端到端低延迟送达，画面跟手流畅。'
            },
            {title: '多设备集中监控', desc: '仪表盘统一呈现全部终端在线状态、CPU/内存负载与告警，一屏掌握全局。'},
            {title: '屏幕录制与复听', desc: '支持 WAV 录音回放与波形播放，配合屏幕快照，构建完整操作留痕与质检闭环。'},
            {title: '文件互传与剪贴板', desc: '主控与被控之间安全互传文件、同步剪贴板，告别 U 盘与第三方工具。'},
            {title: '批量自动化运维', desc: '批量截屏、批量消息下发、定时任务编排，把重复劳动自动化，释放人力。'},
            {title: '操作日志与审计', desc: '全量操作日志可追溯、可检索，满足合规审计要求，纠纷取证有依据。'},
            {title: '智能告警', desc: 'CPU/内存超阈值自动告警，主动发现隐患设备，避免小问题拖成大故障。'},
            {title: '无人值守', desc: '被控端开机自启、自动共享屏幕、托盘常驻，断线自动重连，真正"装好即忘"。'},
            {title: '私有化部署', desc: '全部组件部署于内网，数据不出域，满足等保与行业安全合规要求。'},
          ],
          techs: [
            {
              title: 'WebRTC 点对点低延迟传输',
              desc: '屏幕流与控制指令走 P2P 直连，跨网段通过中继穿透，画面跟手、操控流畅。'
            },
            {
              title: 'Leader 选举多连接协同',
              desc: '控制台多页面同时打开时，自动选举唯一主连接负责实时链路，避免争抢资源。'
            },
            {title: '大文件分块续传', desc: '文件传输采用分块 + 断点续传机制，弱网/中断后可恢复，不丢数据。'},
            {
              title: '会话全程留痕 + 后端自愈',
              desc: '每次远程连接起止时间、时长自动记录，具备后端自愈兜底确保审计数据不丢失。'
            },
            {title: '跨平台桌面端', desc: '主控端与被控端均为 Electron 桌面应用，支持系统托盘、开机自启与后台常驻。'},
            {
              title: '全栈技术栈成熟稳定',
              desc: 'Vue + Electron 前端、WebRTC/PeerJS 实时通信、Spring Boot 后端、Redis 缓存。'
            },
          ],
          info: {
            deliver: '主控端控制台 + 被控端程序 + 中央服务集群 + 业务后端',
            scene: '多产线、多网点终端的统一远程运维与质检管控，适用于需将分散设备纳入同一融合管控平台的制造企业',
            security: '完全私有化部署，信令/媒体流/业务数据全程不出域，满足等保合规',
            deploy: '私有化内网一键部署（数据不出域）',
            cycle: '标准场景 2 周内完成部署上线',
            service: '7×24 技术支持 / 驻场交付 / 培训赋能',
          },
          cta: {
            title: '想看看它如何运转？',
            desc: '预约一次在线演示，我们用真实控制台为你展示远程控制、集中监控与质检闭环。'
          },
        },
      },
    };
  },
  created() {
    this.caseData = this.caseMap[1];
  },
  methods: {
    onContact() {
      this.$router.push({path: '/contact', query: {subject: 'PRODUCT'}});
    },
  },
};
</script>

<style scoped>
.cd-banner {
  background: linear-gradient(135deg, #0B2A4A, #0D4A6E);
  position: relative;
  min-height: 500px;
  margin-top: -30px
}

.banner-content-white-text {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 100%;
  padding: 0 24px
}

.case-center-card {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  border: none;
  background: transparent
}

.main-title {
  font-size: 32px;
  margin-bottom: 10px;
  font-weight: bold;
  color: #fff
}

.sub-title {
  font-size: 18px;
  color: #c0c4cc;
  font-weight: normal;
  letter-spacing: 2px;
  margin: 0
}

.breadcrumb-container {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  background-color: rgba(255, 255, 255, .5);
  padding: 8px 16px;
  border-radius: 4px;
  width: auto;
  min-width: max-content;
}

.cd-container {
  max-width: 1000px;
  margin: 40px auto 60px;
  padding: 0 24px
}

.cd-block {
  margin-bottom: 26px;
  border-radius: 8px
}

.cd-block-header {
  font-size: 18px;
  font-weight: 700;
  color: #0B2A4A;
  border-left: 3px solid #2a7c7e;
  padding-left: 10px
}

.cd-label {
  color: #2a7c7e;
  font-size: 13px;
  letter-spacing: .1em;
  margin-right: 6px
}

.cd-summary {
  font-size: 15px;
  color: #555;
  line-height: 1.9;
  text-indent: 2em;
  white-space: pre-wrap
}

.cd-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px
}

.cd-tag {
  color: #0D4A6E;
  background: rgba(13, 74, 110, .08);
  border-color: transparent
}

.cd-sub {
  font-size: 14.5px;
  color: #666;
  margin-bottom: 24px
}

.cd-three {
  margin-top: 8px
}

.cd-mini {
  border: 1px solid #e8ecf1;
  border-top: 3px solid #2b6cb0;
  border-radius: 8px;
  padding: 22px 18px;
  background: #fafbfc;
  height: 100%
}

.cd-mini.c2 {
  border-top-color: #6b46c1
}

.cd-mini.c3 {
  border-top-color: #2a7c7e
}

.cd-mini-head {
  font-size: 13px;
  font-weight: 700;
  color: #2b6cb0;
  margin-bottom: 12px
}

.cd-mini.c2 .cd-mini-head {
  color: #6b46c1
}

.cd-mini.c3 .cd-mini-head {
  color: #2a7c7e
}

.cd-mini h3 {
  font-size: 16px;
  color: #0B2A4A;
  margin-bottom: 12px
}

.cd-mini ul {
  list-style: none;
  padding: 0
}

.cd-mini li {
  font-size: 13.5px;
  color: #666;
  padding: 6px 0 6px 16px;
  position: relative
}

.cd-mini.c1 li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 12px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2b6cb0
}

.cd-mini.c2 li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 12px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #6b46c1
}

.cd-mini.c3 li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 12px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #2a7c7e
}

.cd-arch {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap
}

.cd-node {
  background: #fff;
  border: 1.5px solid #b8cfe0;
  border-radius: 10px;
  padding: 18px 26px;
  text-align: center;
  min-width: 170px;
  max-width: 240px;
  flex: 1
}

.cd-node h4 {
  font-size: 15.5px;
  color: #0B2A4A;
  margin-bottom: 5px
}

.cd-node-sub {
  font-size: 12.5px;
  color: #888
}

.cd-arrow {
  font-size: 22px;
  color: #6ba3c7;
  font-weight: 700
}

.cd-note {
  margin-top: 20px;
  background: rgba(42, 124, 126, .05);
  border: 1.5px dashed #a8cdd0;
  border-radius: 8px;
  padding: 14px 22px;
  font-size: 13.5px;
  color: #3a5a5a;
  display: flex;
  align-items: center;
  gap: 10px
}

.cd-lock {
  font-size: 16px
}

.cd-tag-arch {
  color: #555;
  border-color: #e8ecf1;
  margin: 4px
}

.cd-tag-arch b {
  color: #2b6cb0
}

.cd-feat-grid {
  margin-top: 4px
}

.cd-feat {
  border: 1px solid #e8ecf1;
  border-top: 3px solid #0B2A4A;
  border-radius: 8px;
  padding: 10px 20px 20px 20px;
  margin-bottom: 14px;
  background: #fff;
  transition: all .2s
}

.cd-feat:hover {
  border-top-color: #2a7c7e;
  box-shadow: 0 4px 12px rgba(0, 0, 0, .08)
}

.cd-feat-gif {
  width: 100%;
  height: 140px;
  margin-bottom: 12px;
  border-radius: 6px;
  overflow: hidden;
  background: #f2f5f8;
  display: flex;
  align-items: center;
  justify-content: center
}

.cd-feat-gif img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block
}

.cd-feat-svg {
  width: 100%;
  height: 100%;
  display: block
}

.cd-feat h4 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #0B2A4A;
  margin-bottom: 8px
}

.cd-feat h4::before {
  content: '';
  display: block;
  width: 5px;
  height: 18px;
  background: linear-gradient(180deg, #2a7c7e, #0B2A4A);
  border-radius: 3px
}

.cd-feat p {
  font-size: 13px;
  color: #666;
  line-height: 1.6
}

.cd-tech-grid {
  margin-top: 4px
}

.cd-tech {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 16px 20px;
  margin-bottom: 12px;
  background: #f7f8fa;
  border-radius: 8px;
  transition: box-shadow .2s
}

.cd-tech:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, .08)
}

.cd-tech-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2a7c7e, #0B2A4A);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-top: 2px
}

.cd-tech b {
  display: block;
  color: #0B2A4A;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 4px
}

.cd-tech-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.6
}

.cd-cta {
  background: linear-gradient(135deg, #0B2A4A, #0D4A6E);
  border-radius: 8px;
  padding: 40px 30px;
  text-align: center;
  color: #fff;
  margin-top: 10px
}

.cd-cta h2 {
  font-size: 22px;
  margin-bottom: 10px
}

.cd-cta p {
  font-size: 14px;
  opacity: .85;
  margin-bottom: 22px
}

@media (max-width: 800px) {
  .cd-banner {
    min-height: 360px;
  }

  .breadcrumb-container {
    bottom: 12px;
    padding: 6px 12px;
  }
  .breadcrumb-container .el-breadcrumb {
    display: inline-flex !important;
    flex-wrap: nowrap !important;
    font-size: 12px;
  }
  .breadcrumb-container .el-breadcrumb__item,
  .breadcrumb-container .el-breadcrumb__inner,
  .breadcrumb-container .el-breadcrumb__separator {
    white-space: nowrap !important;
    flex-shrink: 0 !important;
  }

  .cd-three ::v-deep .el-col,
  .cd-feat-grid ::v-deep .el-col,
  .cd-tech-grid ::v-deep .el-col {
    width: 100%;
  }

  .cd-arch {
    flex-direction: column
  }

  .cd-arrow {
    transform: rotate(90deg)
  }
}
</style>
